const $ = jQuery;

class Header {
  constructor() {
    this.navBtnDom = $('[data-js="navbtn"]');
    this.navContsDom = $('[data-js="navconts"]');
    this.pathname = location.pathname;
    this.init();
    this.resize(640);
    this.current(this.pathname);
  }
  init() {
    this.navBtnDom.on("click", (e) => {
      $(e.currentTarget).toggleClass("expanded");
      this.navContsDom.fadeToggle(100);
    });
  }
  resize(bp) {
    $(window).on("resize", () => {
      let winW = $(window).width();
      if (winW > bp) {
        $(".header-nav").removeAttr("style", "");
        $(".header-menu").removeClass("expanded");
      }
    });
  }
  current(url) {
    const path = url.split("/");
    const category = path[1];
    const target = $('.nav-main li a[href="/' + category + '/"]');
    target.parent().addClass("current");
  }
}

function headerWhite() {
  $(".header").addClass("is-white");
}

class SmoothScroll {
  constructor() {
    $('a[href^="#"]').click(function () {
      const speed = 300;
      const href = $(this).attr("href");
      const target = $(href == "#" || href == "" ? "html" : href);
      const position = target.offset().top;
      $("html, body").animate({ scrollTop: position }, speed, "swing");
      return false;
    });
  }
}

class FormValidation {
  constructor() {
    const sendBtn = $("#formSend");
    const form = $("#form");
    sendBtn.on("click", function () {
      $("[required]").each(function () {
        if ($(this).val()) {
          $(this)
            .parents(".inquiry-container__row")
            .find(".inquiry-error")
            .remove();
          if (
            $(this).val().includes("@yahoo.com") ||
            $(this).val().includes("@gmail.com")
          ) {
            $(this)
              .parents(".inquiry-container__row")
              .append(
                "<p class='inquiry-error'>フリーメールのアドレスです。所属先のメールアドレスを入力してください。</p>"
              );
          }
        } else {
          let inputTitle = $(this)
            .parents(".inquiry-container__row")
            .find(".label")
            .text();
          $(this)
            .parents(".inquiry-container__row")
            .find(".inquiry-error")
            .remove();
          $(this)
            .parents(".inquiry-container__row")
            .append(
              "<p class='inquiry-error'>" + inputTitle + "は必須項目です</p>"
            );
        }
      });
      if ($(".inquiry-error").length > 0) {
        return false;
      }
    });
  }
}

class NewsSortAccordion {
  constructor() {
    this.headDom = $("[data-js='sortHead']");
    this.headDom.on("click", (e) => {
      if ($(".module-sort-wrapper").hasClass("news-detail")) {
        if (window.matchMedia("(max-width: 1023px)").matches) {
          this.toggle(e);
        }
      } else {
        this.toggle(e);
      }
    });
  }
  toggle(e) {
    $(e.currentTarget).parent(".module-sort").toggleClass("active");
    $(e.currentTarget).next().slideToggle(300);
  }
}

class TopAnim {
  constructor() {
    this.rellax();
    this.scrollIn();
  }
  scrollIn() {
    ScrollReveal().reveal(".js-scrollin", {
      delay: 100,
      duration: 900,
      viewFactor: 0.4,
      origin: "bottom",
      distance: "9%",
      reset: false,
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    });
  }
  rellax() {
    const rellax = new Rellax(".js-rellax", {
      speed: 1,
      center: true,
    });
  }
}

class Slick {
  constructor() {
    if ($(".js-carousel").length) {
      $(".js-carousel").slick({
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        variableWidth: true,
        prevArrow: $(".slick-prev"),
        nextArrow: $(".slick-next"),
        responsive: [
          {
            breakpoint: 767,
            settings: {
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              dots: true,
            },
          },
        ],
      });
    }
  }
}

class NewsBackBtn {
  constructor() {
    const btn = $(".news-pager-back a");
    const referer = document.referrer;
    const home_URL = "tmp.01booster.co.jp/";
    if (btn.length) {
      if (referer === home_URL) {
        return false;
      } else if (referer.match(home_URL)) {
        btn
          .attr("onclick", "history.back()")
          .attr("href", "javascript:void(0)");
      }
    }
  }
}

class ShowHiddenForm {
  constructor() {
    const triggerSelect = $('select[name="inquiry-genre"]');
    const hiddenSelect = $(".inquiry-container__row.hidden");
    const genre2_select = $(".genre2");
    const genre2_options = $(".genre2 option");
    triggerSelect.on("change", () => {
      let val = triggerSelect.val();
      if (val === "当社のサービス（企業向け・行政向けなど）") {
        resetAndShow("genre2-type1");
      } else if (val === "運営メディア・イベント（01Channelなど）") {
        resetAndShow("genre2-type3");
      } else if (val === "その他（登壇・取材・採用など）") {
        resetAndShow("genre2-type4");
      } else {
        hiddenSelect.hide();
        // genre2_options.hide();
        // genre2_options.attr("selected", false);
        $(".genre2").val("");
        // genre2_select.attr("required", false);
      }
    });
    function resetAndShow(className) {
      console.log(className);
      hiddenSelect.show();
      genre2_options.each(function () {
        const type = $(this).attr("class");
        const wrap = $(this).parents().attr("class");

        if (type == className) {
          if (wrap == "wrap") {
            $(this).unwrap();
          }
        } else {
          if (wrap !== "wrap") {
            $(this).wrap("<span class='wrap' style='display:none'>");
          }
        }
      })
      $(".initial").unwrap();
      // genre2_options.wrap("<span display='none'>");
      // genre2_options.attr("selected", false);
      // genre2_select.attr("required", true);
      $(".genre2").val("");
      // $(".initial").unwrap();
      // $(className).unwrap();
    }
  }
}

$(() => {
  new Header();
  new SmoothScroll();
  new FormValidation();
  new NewsSortAccordion();
  new Slick();
  if (location.pathname == "/") {
    new TopAnim();
  }
  new NewsBackBtn();
  new ShowHiddenForm();
});
